import ErrorIcon from '@mui/icons-material/Error'

import { EmptyState } from 'components/empty-state/EmptyState'

export const ErrorBoundaryContent = (): JSX.Element => (
  <EmptyState
    dataTestId="error-boundary-content"
    icon={<ErrorIcon style={{ fontSize: 48 }} />}
    title="Something went wrong."
    description="Our team has been notified of this error and will get to work on fixing it."
    fullHeight="container"
    textWidth="300px"
    actions={[{ label: 'Refresh page', onClick: () => location.reload() }]}
  />
)
